var _rect, _mask, _ellipse, _path, _mask2, _ellipse2, _path2, _mask3, _ellipse3, _path3, _mask4, _ellipse4, _path4, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 13,
    rx: 1.5,
    stroke: "#9A9BB1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5839_3229",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 1,
    ry: 1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5,
    cy: 5,
    rx: 1,
    ry: 1,
    fill: "#1A1446"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5V5V7C6.10457 7 7 6.10457 7 5H5ZM5 5V5H3C3 6.10457 3.89543 7 5 7V5ZM5 5V5V3C3.89543 3 3 3.89543 3 5H5ZM5 5V5H7C7 3.89543 6.10457 3 5 3V5Z",
    fill: "#9A9BB1",
    mask: "url(#path-2-inside-1_5839_3229)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_5839_3229",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 5,
    rx: 1,
    ry: 1
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 5,
    rx: 1,
    ry: 1,
    fill: "#1A1446"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5V5V7C15.1046 7 16 6.10457 16 5H14ZM14 5V5H12C12 6.10457 12.8954 7 14 7V5ZM14 5V5V3C12.8954 3 12 3.89543 12 5H14ZM14 5V5H16C16 3.89543 15.1046 3 14 3V5Z",
    fill: "#9A9BB1",
    mask: "url(#path-4-inside-2_5839_3229)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_5839_3229",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 5,
    rx: 1,
    ry: 1
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 5,
    rx: 1,
    ry: 1,
    fill: "#1A1446"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5V5V7C9.10457 7 10 6.10457 10 5H8ZM8 5V5H6C6 6.10457 6.89543 7 8 7V5ZM8 5V5V3C6.89543 3 6 3.89543 6 5H8ZM8 5V5H10C10 3.89543 9.10457 3 8 3V5Z",
    fill: "#9A9BB1",
    mask: "url(#path-6-inside-3_5839_3229)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_5839_3229",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 5,
    rx: 1,
    ry: 1
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 5,
    rx: 1,
    ry: 1,
    fill: "#1A1446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5V5V7C12.1046 7 13 6.10457 13 5H11ZM11 5V5H9C9 6.10457 9.89543 7 11 7V5ZM11 5V5V3C9.89543 3 9 3.89543 9 5H11ZM11 5V5H13C13 3.89543 12.1046 3 11 3V5Z",
    fill: "#9A9BB1",
    mask: "url(#path-8-inside-4_5839_3229)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.86198,
    y: 9.30558,
    width: 10.2778,
    height: 0.833333,
    rx: 0.416667,
    fill: "#1A1446",
    stroke: "#9A9BB1",
    strokeWidth: 0.833333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.e7af7939383ef9d87ca9d5a738da5514.svg";
export { ForwardRef as ReactComponent };